import React from "react";
import "./DataTableCard.scss";
import { BasicIndicator } from "components/BasicIndicator/BasicIndicator";
import CardPreview from "components/CardPreview/CardPreview";
const DataTableCard = (props: any) => {
  const { title, config, data } = props;
  return (
    <div className="data-table-card-container">
      <h2 className="card-title">{title}</h2>
      <div>
        {/* <BasicIndicator
          color={config.color}
          value={data?.recordsCount || 0}
          label={"Registros"}
        /> */}
        <CardPreview
          type={config?.previewType}
          icon={config?.previewIcon}
          valueDefinitions={config?.previewValueDefinitions}
          data={data}
        />
      </div>

    </div>
  );
};

export { DataTableCard };
